import { useMemo } from 'react';
import { useNavigationGlobalResource } from '@atlassian/jira-navigation-apps-sidebar-common/src/controllers/common/navigation-global-resource/index.tsx';
import { withThrowOnError } from '@atlassian/jira-navigation-apps-sidebar-common/src/utils/throw-when-no-data-and-error/index.tsx';
import { useGlobalSettingsSystemConnectItems as useGlobalSettingsSystemConnectItemsWithoutThrowOnError } from '@atlassian/jira-navigation-apps-sidebar-connect/src/controllers/global-settings-system/index.tsx';
import { useTenantContext } from '@atlassian/jira-tenant-context-controller/src/components/tenant-context/index.tsx';
import type { UseFeaturesReturn } from './types.tsx';
import { extractData } from './utils/extract-data.tsx';

export const useFeatures = withThrowOnError((): UseFeaturesReturn => {
	// eslint-disable-next-line jira/react/no-usage-of-hooks-outside-components
	const { data, loading, error } = useNavigationGlobalResource();
	// eslint-disable-next-line jira/react/no-usage-of-hooks-outside-components
	const { isDevMode, isAdmin } = useTenantContext();

	const extractedData = useMemo(
		() => data && extractData(data, isDevMode, isAdmin),
		[data, isDevMode, isAdmin],
	);
	return { data: extractedData, loading, error };
});

export const useGlobalSettingsSystemConnectItems = withThrowOnError(
	useGlobalSettingsSystemConnectItemsWithoutThrowOnError,
);
